<template>
  <div class='h100vh-150 h-normalBg'>
    <div class='h-normalContainter'>
      <div class='row h-chart-titleBg h-nomargin'>
        <!-- <div class='col-sm-1'></div>
        <div class='col-sm-4 h-chart-titleText'>{{ option.charTitle }}</div> -->
        <div class='col-sm-4'>
          <div class='h-toolbarBg' style="padding-top:10px; width:200px">

             <ejs-toolbar>
              <e-items>
                <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click='refresh' ></e-item>
                <e-item prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$t("Alarm.export")' :click='exportData'></e-item>
              </e-items>
            </ejs-toolbar>
            <div class='h-inputBox'>
              Top：<ejs-textbox v-model='queryConditions.keywords' :width="350" clipMode='EllipsisWithTooltip' :change="updateKeywords" @keydown.native.enter='keydownFunc'></ejs-textbox>
            </div>
          </div>
        </div>
        <div class='col-sm-2 h-chart-selectText' style="width:400px">
         <button class="e-control e-btn e-lib e-primary e-flat" data-ripple="true" @click='getTodayDate'   >{{$t('Alarm.thisDay')}}</button>
          <span></span>
          <button  @click='getWeekDate'  class="e-control e-btn e-lib e-primary e-flat" data-ripple="true">{{$t('Alarm.thisWeek')}}</button >
          <span></span>
          <button  @click='getMonthDate'  class="e-control e-btn e-lib e-primary e-flat" data-ripple="true" >{{$t('Alarm.thisMonth')}}</button >
          <span></span>
          <button  @click='getYearDate' class="e-control e-btn e-lib e-primary e-flat" data-ripple="true" >{{$t('Alarm.thisYear')}}</button >
        </div>
        <div class='col-sm-3' style="width:20%">
          <div class='col-sm-3 h-chart-datetimepickerText' style="width:35%"><span>{{$t('Alarm.notifystart')}}：</span></div>
          <div class='col-sm-9 h-chart-date-datetimepicker' style="width:65%;padding-right: 5px;">
            <ejs-datetimepicker :format='dateFormat' :step='60' :locale='locale' timeFormat='HH:mm:ss' :value='startDateValue' :change='changeStart'></ejs-datetimepicker>
          </div>
        </div>
        <div class='col-sm-3'  style="width:20%">
          <div class='col-sm-3 h-chart-datetimepickerText' style="width:35%"><span>{{$t('Alarm.notifyend')}}：</span></div>
          <div class='col-sm-9 h-chart-date-datetimepicker' style="width:65%;padding-right: 5px;">
            <ejs-datetimepicker :format='dateFormat' :step='60' :locale='locale' timeFormat='HH:mm:ss' :value='endDateValue' :change='changeEnd'></ejs-datetimepicker>
          </div>
        </div>
      </div>
      <div class='row h-nomargin h-full-container width-100vw h100-80'>
        <div id='myTopChart' class='width-100vw h100'></div>
      </div>
    </div>
  </div>
</template>
<script>
const echarts = require('echarts');

const now = new Date();
let nowDayOfWeek = now.getDay();
if (nowDayOfWeek === 0) {
  nowDayOfWeek = 6;
} else {
  nowDayOfWeek -= 1;
}
const nowDay = now.getDate();
const nowMonth = now.getMonth();
let nowYear = now.getYear();
nowYear += (nowYear < 2000) ? 1900 : 0;

export default {
  name: 'StaticsChar',
  props: {
    url: { type: String, default: '' },
    roleNe: {
      type: Array,
      default() {
        return [];
      }
    },
    option: {
      type: Object,
      default() {
        return {
          charTitle: '',
          allNumTitle: ''
        };
      }
    }
  },
  data() {
    return {
      myTopChart: null,
      locale: localStorage.getItem('locale'),
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      queryConditions: {
        systemId: '1',
        startTime: '',
        endTime: '',
        advanceConditions:{},
        keywords:''
      },
      charSetting: {
        seriesName: [
          `${this.option.allNumTitle}(${this.$t('Alarm.singleNetwork')})`
        ],
        seriesColor: ['#1E90FF', '#ff8000', '#facc14', '#13c2c2', '#29aa4f']
      },
      charDatas: {
        counts: [1,2,15,78],
        neList: ["ne1","ne2","ne3","ne4"]
      }
    };
  },
  computed: {
    startDateValue() {
      const dateRange = this.queryConditions.startTime ? `${this.getDate(this.queryConditions.startTime)}` : '';
      return dateRange;
    },
    endDateValue() {
      const dateRange = this.queryConditions.endTime ? `${this.getDate(this.queryConditions.endTime)}` : '';
      return dateRange;
    },
    getSeriesData() {
      const seriesData = [];
      for (let i = 0; i < this.charDatas.neList.length; i++) {
        seriesData.push({
          ne: this.charDatas.neList[i]
        });
      }
      return seriesData;
    }
  },
  watch: {
    roleNe() {
      this.getTopData();
    }
  },
  methods: {
    getDate(date) {
      return this.turnToFormateDate(new Date(date));
    },
    turnToFormateDate(dateValue) {
      let month = dateValue.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let day = dateValue.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      let hour = dateValue.getHours();
      if (hour < 10) {
        hour = `0${hour}`;
      }
      let minutes = dateValue.getMinutes();
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      let sec = dateValue.getSeconds();
      if (sec < 10) {
        sec = `0${sec}`;
      }
      return `${dateValue.getFullYear()}-${month}-${day} ${hour}:${minutes}:${sec}`;
    },
    getMonthDays(month) {
      const monthStartDate = new Date(nowYear, month, 1);
      const monthEndDate = new Date(nowYear, month + 1, 1);
      const days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
      return days;
    },
    getTodayDate() {
      this.queryConditions.startTime = new Date(nowYear, nowMonth, nowDay, 0, 0, 0).getTime();
      this.queryConditions.endTime = new Date(nowYear, nowMonth, nowDay, 23, 59, 59).getTime();
    },
    getWeekDate() {
      this.queryConditions.startTime = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek, 0, 0, 0).getTime();
      this.queryConditions.endTime = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek), 23, 59, 59).getTime();
    },
    getMonthDate() {
      this.queryConditions.startTime = new Date(nowYear, nowMonth, 1, 0, 0, 0).getTime();
      this.queryConditions.endTime = new Date(nowYear, nowMonth, this.getMonthDays(nowMonth), 23, 59, 59).getTime();
    },
    getYearDate() {
      this.queryConditions.startTime = new Date(nowYear, 0, 1, 0, 0, 0).getTime();
      this.queryConditions.endTime = new Date(nowYear, 11, 31, 23, 59, 59).getTime();
    },
    changeStart(args) {
      this.queryConditions.startTime = new Date(args.value).getTime();
      this.getTopData();
    },
    changeEnd(args) {
      this.queryConditions.endTime = new Date(args.value).getTime();
      this.getTopData();
    },
    getChartOption() {
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          orient: 'vertical',
          right: '5%',
          top: 'middle',
          itemGap: 40,
          itemWidth: 22,
          itemHeight: 12,
          textStyle: {
            padding: [0, 0, 0, 25]
          }
        },
        grid: {
          left: '5%',
          right: '18%',
          top: '5%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#d9d9d9'
            }
          },
          axisTick: {
            alignWithLabel: true,
            interval: 0,
            length: 9
          },
          axisLabel: {
            margin: 20,
            color: '#5a5a5a'
          },
          data: this.charDatas.neList
        }],
        yAxis: [{
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            margin: 20,
            color: '#5a5a5a'
          },
          splitLine: {
            lineStyle: {
              color: '#e8e8e8',
              type: 'dashed'
            }
          }
        }],
        color: this.charSetting.seriesColor,
        series: [{
          name: this.charSetting.seriesName[0],
          type: 'bar',
          stack: 'ne-name',
          width: '2',
          data: this.charDatas.counts
        }]
      };
      return option;
    },
    init() {
      this.queryConditions.keywords=10;
      this.getWeekDate();
      this.myTopChart = echarts.init(document.getElementById('myTopChart'));
      this.getTopData();
    },
    getTopData() {
      this.myTopChart.showLoading({
        text: '',
      });

      let principal = sessionStorage.getItem('principal');
      let user = JSON.parse(principal);
      let userId = user.userId;

      this.$axios.post(this.url, {
        start: this.queryConditions.startTime,
        end: this.queryConditions.endTime,
        neList: this.roleNe,
        userId:userId,
        top: Number(this.queryConditions.keywords)
      }).then((response) => {
        this.myTopChart.hideLoading();
        if (response && response.status === 200) {
          this.charDatas = response.data;
          this.myTopChart.clear();
          this.myTopChart.setOption(this.getChartOption(), true);
          this.myTopChart.resize();
        }
      });
    },
    resize() {
      this.myTopChart.resize();
    },
    exportData(){
      axios({
        method: 'post',
        url: '/lte/ems/fm/alarmhistory/exportData',
        data: {
          data:this.myTopChart.getDataURL()
        },
        // 二进制流文件，一定要设置成blob，默认是json
        responseType: 'blob'
      }).then(res => {
        const link = document.createElement('a');
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', nowYear+""+Number(nowMonth+1)+""+nowDay+`.xlsx`);
        document.body.appendChild(link);
        link.click()
        document.body.removeChild(link);
      })


    },
    //输入框输入内容后直接触发
    updateKeywords() {
      this.$emit('keywords', this.queryConditions.keywords);
      if(!(/(^[1-9]\d*$)/.test(this.queryConditions.keywords))){
         this.queryConditions.keywords = 10
      }else if(this.queryConditions.keywords > 100){
        this.queryConditions.keywords = 100;
      }
    },
    //输入内容后回车触发
    keydownFunc() {
      if (this.queryConditions.keywords === '') {
        this.queryConditions.keywords = '';
        this.notices('refresh');
      } else {
        this.notices('keywords');
      }
    },
    notices(args) {
      switch (args) {
        case 'refresh':
          this.refresh();
          break;
        case 'keywords':
          // this.$refs.alarmTable.conditionsStatus = false;
          this.getTopData();
          break;
      }

    },
    refresh(){
      this.queryConditions.advanceConditions = {};
      this.queryConditions.keywords = 10;
      this.getTopData();
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style>
  #container {
    height: 700px;
  }
</style>
